// @react-functional
import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const headerWidth = 120;
const marginBottomEl = 40;

export const useIsElementVisible = (elementId: string) => {
  const [isVisible, setIsVisible] = useState(false);

  const onScroll = () => {
    const element = document.getElementById(elementId);

    if (element) {
      const { top, right, bottom, left } = element.getBoundingClientRect();
      // Added two pixel to each in order to support IE11. IE starts at 2,2 (pixels) instead of 0,0.
      const topWithOffset = top - (headerWidth + 2);
      const bottomWithOffset = bottom - (marginBottomEl + 2);
      if (
        topWithOffset <= 0 &&
        left >= 0 &&
        bottomWithOffset > 0 &&
        right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', debounce(onScroll, 10));
    return () => window.removeEventListener('scroll', onScroll);
  });

  return { isVisible };
};
